<!-- An tag for stylists to quickly see the average star rating of an item when styling a member. -->
<template>
  <SequinTag
    class="star-rating tag"
    :class="styleColor?.numStyleStarRatings ? 'filled' : 'unfilled'">
    <SvgStar
      class="star"
      width="12"
      height="12"/>
    <span
      v-if="styleColor?.numStyleStarRatings"
      class="text-white fine-print">
      {{ styleColor.avgStyleStarRating }}
    </span>
  </SequinTag>
</template>

<script setup>
import SequinTag from '@/components/global/sequin/SequinTag.vue'
import SvgStar from '@/components/global/svg/SvgStar.vue'

defineProps({
  styleColor: {
    type: Object,
    required: true
  },
  /** @type {PropType<StyleColorSource>} */
  styleColorSource: {
    type: Object,
    required: true
  },
  styleColorSourceIndex: {
    type: Number,
    default: () => null
  },
  size: {
    type: String,
    default: 'medium',
    validator: value => ['x-large', 'large', 'medium', 'small', 'tiny'].includes(value)
  }
})
</script>

<style lang="scss" scoped>
@import './StyleColorQuickActions.scss';
.star-rating  {
  &.filled {
    width: fit-content !important;
    .star {
      fill: white;
      stroke-width: 0;
    }
  }
  &.unfilled {
    .star {
      fill: none;
      stroke: white;
      stroke-width: 2;
    }
  }
}
</style>
